import $ from 'jquery'
import { fromEvent, BehaviorSubject } from 'rxjs'
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators'
import SubjectRepository from './subject-repository'

export default class ScreenSizeSubjectRepository {
  constructor () {
    this._bindUIActions()
    this._subjectRepository = new SubjectRepository(this._screenSize$)
  }

  getScreensizeSubject () {
    return this._screenSize$
  }

  getMinAspectRatioSubject (aspectRatio) {
    return this._subjectRepository.getOrRegisterSubject(
      ['min-aspect-ratio', aspectRatio],
      screenSize => screenSize.width / screenSize.height >= aspectRatio
    )
  }

  getMaxAspectRatioSubject (aspectRatio) {
    return this._subjectRepository.getOrRegisterSubject(
      ['max-aspect-ratio', aspectRatio],
      screenSize => screenSize.width / screenSize.height <= aspectRatio
    )
  }
  _bindUIActions () {
    this._screenSize$ = new BehaviorSubject({
      width: $(window).width(),
      height: $(window).height()
    })

    const resizeDebounced$ = fromEvent(window, 'resize').pipe(debounceTime(100))
    resizeDebounced$
      .pipe(
        map(() => {
          return {
            width: $(window).width(),
            height: $(window).height()
          }
        }),
        distinctUntilChanged((a, b) => {
          return a.width === b.width && a.height === b.height
        })
      )
      .subscribe(screenSize => {
        this._screenSize$.next(screenSize)
      })
  }
}
